import classNames from 'classnames';
import { forwardRef } from 'react';
const timelineStepCss = "t1xoi9ri";
export const TimelineStep = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timelineStepCss, props.className)} />;
});
const iconContainerCss = "i1e4ysmd";
export const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const descriptionCss = "ds45wj5";
export const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const rescheduleReasonTextCss = "r1s58567";
export const RescheduleReasonText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rescheduleReasonTextCss, props.className)} />;
});
const containerCss = "c1881jpr";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");